import Icon from "./Icon";
import Button from "./Button";
export default Icon;
Icon.Button = Button;